import Users from '@/views/admin/users/Users'
import UsersDetails from '@/views/admin/users/Details'
import Schools from '@/views/admin/schools/Schools'
import SchoolsDetails from '@/views/admin/schools/Details'
import Competitions from '@/views/admin/competitions/Competitions'
import Registration from '../views/admin/competitions/Registration'
import CompetitionsInvoicing from '@/views/admin/competitions/CompetitionsInvoicing'
import Questions from '@/views/admin/competitions/Questions'

export default [
  {
    path: '/admin/competitions',
    name: 'admin.competitions',
    component: Competitions,
    meta: {
      authRequired: true,
      requiredRole: 0
    }
  },
  {
    path: '/admin/competitions/:id',
    name: 'admin.competition',
    component: Competitions,
    meta: {
      authRequired: true,
      requiredRole: 0
    }
  },
  {
    path: '/admin/competitions/:id/invoicing',
    name: 'admin.competition.invoicing',
    component: CompetitionsInvoicing,
    meta: {
      authRequired: true,
      requiredRole: 0
    }
  },
  {
    path: '/admin/registration/:id',
    name: 'admin.registration',
    component: Registration,
    props: true,
    meta: {
      authRequired: true,
      requiredRole: 0
    }
  },
  {
    path: '/admin/questions/:id',
    name: 'admin.questions',
    component: Questions,
    meta: {
      authRequired: true,
      requiredRole: 0
    }
  },
  {
    path: '/admin/users',
    name: 'admin.users',
    component: Users,
    meta: {
      authRequired: true,
      requiredRole: 0
    }
  },
  {
    path: '/admin/users/:id',
    name: 'admin.users.details',
    component: UsersDetails,
    meta: {
      authRequired: true,
      requiredRole: 0
    }
  },
  {
    path: '/admin/schools',
    name: 'admin.schools',
    component: Schools,
    meta: {
      authRequired: true,
      requiredRole: 0
    }
  },
  {
    path: '/admin/schools/:id',
    name: 'admin.schools.details',
    component: SchoolsDetails,
    meta: {
      authRequired: true,
      requiredRole: 0
    }
  }
]



//////////////////
// WEBPACK FOOTER
// ./src/router/routes.admin.js
// module id = 978
// module chunks = 1